export enum HomeEventName {
  ACTIVATE_NOW_BUTTON_CLICKED = "home cards activate now button clicked",
}
